import createVueApp from '@/common/create_app'
import { useGalleryStore } from '@/stores/gallery'

Styxie.Initializers.Galleries = {
  show: async(props) => {
    const { default: Gallery } = await import('@/vue_widgets/gallery/index.vue')
    createVueApp(Gallery, {
      state: (pinia) => {
        useGalleryStore(pinia).setConfig(props)
      }
    })
  }
}
